import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { Slide } from '@progress/kendo-react-animation';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import Icon from '@ricoh/ria.client.core/components/icon';
import { Z_INDEX } from '@ricoh/ria.client.core/constants/ui/layout';
import classNames from 'classnames';

import styles from './_.module.scss';

import type { ToastProps, ToastRef } from './_.type';

import useToastHooks from './_.hook';

/** Toast. */
export default memo(
  forwardRef(function Toast(props: ToastProps, ref: ForwardedRef<ToastRef>): ReactNode {
    const { states, events } = useToastHooks(props, ref);

    return (
      <NotificationGroup
        className={classNames(styles.notificationGroup, 'bottom-0 end-0 me-2')}
        style={{
          zIndex: Z_INDEX.MAX - 1,
        }}
      >
        <Slide direction="up">
          {Object.entries(states.items).map(([key, { type = 'info', title, message }]) => (
            <Notification
              key={key}
              type={{ style: type }}
              closable
              onClose={events.onClose(key)}
              className={classNames(styles[`${type === 'error' ? 'danger' : type}Notification`], 'w-xs gap-2 shadow-sm')}
            >
              <div className="d-flex gap-2">
                <div className="d-flex align-items-center">
                  <Icon name={states.iconName(type)} />
                </div>

                <div className="flex-fill">
                  <h6 className="mb-1">{title}</h6>
                  <span className="fs-7">{message}</span>
                </div>
              </div>
            </Notification>
          ))}
        </Slide>
      </NotificationGroup>
    );
  }),
);
